import { useUI } from "@/context/UIContext";
import { EntityModal } from "@/components/modals/EntityModals";
import { QuickActionModal, CompleteActionModal } from "@/components/modals/ActionModals";
import { OpportunityModal } from "@/components/opportunities/OpportunityModal";
import { TaskModal } from "@/components/modals/TaskModal";

export function GlobalModals() {
  const {
    quickAction,
    completeAction,
    entityModal,
    taskModal,
    setQuickAction,
    setCompleteAction,
    setEntityModal,
    setTaskModal,
    bump,
  } = useUI();

  return (
    <>
      {taskModal && (
        <TaskModal
          open
          record={taskModal.record}
          prefill={taskModal.prefill}
          backdate={!!taskModal.backdate}
          onClose={() => setTaskModal(null)}
          onSuccess={(d) => {
            bump();
            taskModal.onSuccess && taskModal.onSuccess(d);
          }}
        />
      )}
      {quickAction && (
        <QuickActionModal
          open
          prefill={quickAction.prefill}
          record={quickAction.prefill?.id ? quickAction.prefill : undefined}
          onClose={() => setQuickAction(null)}
          onSuccess={(d) => {
            bump();
            quickAction.onSuccess && quickAction.onSuccess(d);
          }}
        />
      )}
      {completeAction && (
        <CompleteActionModal
          open
          action={completeAction.action}
          onClose={() => setCompleteAction(null)}
          onSuccess={() => {
            bump();
            completeAction.onSuccess && completeAction.onSuccess();
          }}
        />
      )}
      {entityModal && entityModal.type === "opportunity" && (
        <OpportunityModal
          open
          prefill={entityModal.prefill}
          record={entityModal.record}
          onClose={() => setEntityModal(null)}
          onSuccess={(d) => {
            bump();
            entityModal.onSuccess && entityModal.onSuccess(d);
          }}
        />
      )}
      {entityModal && entityModal.type !== "opportunity" && (
        <EntityModal
          open
          type={entityModal.type}
          prefill={entityModal.prefill}
          record={entityModal.record}
          onClose={() => setEntityModal(null)}
          onSuccess={(d) => {
            bump();
            entityModal.onSuccess && entityModal.onSuccess(d);
          }}
        />
      )}
    </>
  );
}
